import { render, staticRenderFns } from "./ToolbarNotifications.vue?vue&type=template&id=82ddf21e"
import script from "./ToolbarNotifications.vue?vue&type=script&lang=js"
export * from "./ToolbarNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82ddf21e')) {
      api.createRecord('82ddf21e', component.options)
    } else {
      api.reload('82ddf21e', component.options)
    }
    module.hot.accept("./ToolbarNotifications.vue?vue&type=template&id=82ddf21e", function () {
      api.rerender('82ddf21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toolbar/ToolbarNotifications.vue"
export default component.exports